import { useEffect } from 'react';

const useViewportMeta = () => {
  useEffect(() => {
    const addMaximumScaleToMetaViewport = () => {
      const metaTag = document.querySelector('meta[name=viewport]');
      if (metaTag !== null) {
        let content = metaTag.getAttribute('content') ?? '';
        // eslint-disable-next-line no-useless-escape
        const re = /maximum\-scale=[0-9\.]+/g;
        if (re.test(content)) {
          content = content.replace(re, 'maximum-scale=1.0');
        } else {
          content = [content, 'maximum-scale=1.0'].join(', ');
        }
        metaTag.setAttribute('content', content);
      }
    };

    const checkIsIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

    const checkIsAndroid = () => /Android/.test(navigator.userAgent);

    if (checkIsIOS() || checkIsAndroid()) {
      addMaximumScaleToMetaViewport();
    }
  }, []);
};

export default useViewportMeta;
